import { Box, SxProps } from '@mui/material'
import React from 'react'
import colors from 'src/utils/colors'

export const NotificationBadge = ({ sx, variant = 'large' }: { sx?: SxProps, variant?: 'large' | 'small' }) => {
  const styles = {
    width: variant === 'large' ? '10px' : '8px',
    height: variant === 'large' ? '10px' : '8px',
    backgroundColor: colors.darkBlue,
    display: 'inline-block',
    marginLeft: variant === 'large' ? '12px' : '8px',
    borderRadius: '50%',
    ...sx
  };

  return (
    <Box component="span" sx={styles} />
  )
}
